(function($R)
{
  $R.add('plugin', 'handle', {
      init: function(app)
      {
          this.app = app;
          this.opts = app.opts;
          this.$doc = app.$doc;
          this.$body = app.$body;
          this.editor = app.editor;
          this.marker = app.marker;
          this.keycodes = app.keycodes;
          this.container = app.container;
          this.selection = app.selection;

          // local
          this.handleTrigger = (typeof this.opts.handleTrigger !== 'undefined') ? this.opts.handleTrigger : '@';
          this.handleStart = (typeof this.opts.handleStart !== 'undefined') ? this.opts.handleStart : 0;
          this.handleStr = '';
          this.handleLen = this.handleStart;
      },
      // public
      start: function()
      {
          if (!this.opts.handle) return;

          this._pastedRecently = false;

          var $editor = this.editor.getElement();
    $editor.on('keyup.redactor-plugin-handle', this._handle.bind(this));
          $editor.on('keydown.redactor-plugin-handle', this._listen.bind(this));

          // Suppress autocomplete after paste — pasted @usernames are already
          // complete and will be linked server-side. Without this, the keyup
          // from Ctrl+V triggers the dropdown for the last pasted mention, and
          // if the user submits before selecting, that mention won't be linked.
          $editor.on('paste.redactor-plugin-handle', function() {
              this._pastedRecently = true;
              this._hideForce();
              setTimeout(function() {
                  this._pastedRecently = false;
              }.bind(this), 500);
          }.bind(this));
  },
  stop: function()
  {
          var $editor = this.editor.getElement();

    $editor.off('.redactor-plugin-handle');
          this.$doc.off('.redactor-plugin-handle');

          var $list = $R.dom('#redactor-handle-list');
          $list.remove();
  },

  // private
  _handle: function(e)
  {
      var key = e.which;
    var ctrl = e.ctrlKey || e.metaKey;
    var arrows = [37, 38, 39, 40];

    if (key === this.keycodes.DELETE
        || key === this.keycodes.ESC
        || key === this.keycodes.SHIFT
        || ctrl
        || (arrows.indexOf(key) !== -1)
        || this._pastedRecently
    )
    {
      return;
    }

          // Dynamically extract the text between the last @ and the caret
          // instead of relying on a keystroke counter.
          //
          // NOTE: we deliberately do NOT use selection.getTextBeforeCaret(),
          // which reads from the start of the WHOLE editor and flattens block
          // boundaries with no separator. After "some text" + Enter + "@", it
          // returns "some text@" — the "@ preceded by whitespace" guard below
          // then sees a letter before the "@" and wrongly suppresses the
          // dropdown. Scoping to the current block treats each new line/
          // paragraph as a fresh boundary.
          var textBeforeCaret = this._getBlockTextBeforeCaret(50);
          if (!textBeforeCaret) {
              this._hideForce();
              return;
          }

          var triggerIndex = textBeforeCaret.lastIndexOf(this.handleTrigger);
          if (triggerIndex === -1) {
              this._hideForce();
              return;
          }

          // Only trigger if @ is at start or preceded by whitespace
          if (triggerIndex > 0) {
              var charBefore = textBeforeCaret.charAt(triggerIndex - 1);
              if (charBefore && !/\s/.test(charBefore)) {
                  this._hideForce();
                  return;
              }
          }

          var searchStr = textBeforeCaret.substring(triggerIndex + 1);

          // Don't trigger if there's a space in the search string (mention ended)
          if (/\s/.test(searchStr)) {
              this._hideForce();
              return;
          }

          // Update handleStr and handleLen to stay in sync
          this.handleStr = searchStr;
          this.handleLen = searchStr.length;

          if (this.handleLen >= this.handleStart) {
              this._load();
          } else {
              this._hideForce();
          }
  },
      // Text from the start of the CURRENT block to the caret (last `len` chars).
      // Block-scoped so a newly created paragraph (after Enter) starts a fresh
      // boundary instead of being concatenated with the previous line's text.
      _getBlockTextBeforeCaret: function(len) {
          var range = this.selection.getRange();
          if (!range) return '';

          var clone = range.cloneRange();
          clone.collapse(true);

          // Anchor the range start to the current block; fall back to the editor
          // root if no block is resolved (e.g. caret directly in the editor div).
          var block = this.selection.getBlock();
          var startNode = block || this.editor.getElement().get();
          try {
              clone.setStart(startNode, 0);
          } catch (err) {
              return '';
          }

          return clone.toString().slice(-len);
      },
      _listen: function(e) {
          var key = e.which;
          var ks = this.keycodes;

          // The paste-suppression flag should only swallow the keyup that the
          // paste action itself emits (Ctrl+V release). Those keyups fire BEFORE
          // any new keydown, so the first real keydown after a paste means the
          // user is now actively typing — re-enable autocomplete immediately so
          // typing a fresh "@mention" right after pasting still opens the list.
          // Skip pure modifier keys and paste combos so a second Ctrl+V doesn't
          // clear the flag prematurely.
          if (this._pastedRecently
              && !(e.ctrlKey || e.metaKey)
              && key !== ks.SHIFT && key !== 17 && key !== 18) {
              this._pastedRecently = false;
          }

          // listen enter
          if (this._isShown() && key === ks.ENTER) {
              var $item = this._getActiveItem();
              if ($item.length === 0) {
                  this._hideForce();
                  return;
              }
              else {
                  e.preventDefault();
                  this._replace(e, $item);
                  this._hideForce();
                  return;
              }
          }

          // listen down / up
          if (this._isShown() && (key === 40 || key === 38)) {
              e.preventDefault();

              var $item = this._getActiveItem();
              if ($item.length === 0) {
                  var $first = this._getFirstItem();
                  this._setActive($first);
              }
              // down
              else if (key === 40) {
                  this._setNextActive($item);
              }
              // up
              else if (key === 38) {
                  this._setPrevActive($item);
              }

              return;
          }
      },
      _getItems: function() {
          return this.$list.find('a');
      },
      _getActiveItem: function() {
          return this._getItems().filter(function(node) {
              return $R.dom(node).hasClass('active');
          });
      },
      _getFirstItem: function() {
          return this._getItems().first();
      },
      _getLastItem: function() {
          return this._getItems().last();
      },
      _setActive: function($el) {
          this._getItems().removeClass('active');
          $el.addClass('active');

          var itemHeight = $el.outerHeight();
          var itemTop = $el.position().top;
          var itemsScrollTop = this.$list.scrollTop();
          var scrollTop = itemTop + itemHeight * 2;
          var itemsHeight = this.$list.outerHeight();

          this.$list.scrollTop(
              scrollTop > itemsScrollTop + itemsHeight ? scrollTop - itemsHeight :
                  itemTop - itemHeight < itemsScrollTop ? itemTop - itemHeight :
                  itemsScrollTop
          );
      },
      _setNextActive: function($el) {
          var $next = $el.next();
          if ($next.length !== 0) {
              this._setActive($next);
          }
          else {
              var $first = this._getFirstItem();
              this._setActive($first);
          }
      },
      _setPrevActive: function($el) {
          var $prev = $el.prev();
          if ($prev.length !== 0) {
              this._setActive($prev);
          }
          else {
              var $last = this._getLastItem();
              this._setActive($last);
          }
      },
  _load: function()
  {
      $R.ajax.post({
          url: this.opts.handle,
          data: 'handle=' + this.handleStr,
          success: this._parse.bind(this)
      });
  },
  _parse: function(json)
  {
      if (json === '') return;

          var data = (typeof json === 'object') ? json : JSON.parse(json);

          this._build();
          this._buildData(data);
  },
  _build: function()
  {
          this.$list = $R.dom('#redactor-handle-list');
          if (this.$list.length === 0)
          {
              this.$list = $R.dom('<div id="redactor-handle-list">');
              this.$body.append(this.$list);
          }
      },
      _buildData: function(data)
      {
          this.data = data;

          this._update();
          this._show();
      },
      _update: function()
      {
          this.$list.html('');

          for (var key in this.data)
          {
              var $item = $R.dom('<a href="#">');
              $item.html(this.data[key].item);
              $item.attr('data-key', key);
              $item.on('click', this._replace.bind(this));

              this.$list.append($item);
          }

          // position
      var $container = this.container.getElement();
          var containerOffset = $container.offset();
          var pos = this.selection.getPosition();

          this.$list.addClass('open');
          this.$list.css({
              top: (pos.top + pos.height + this.$doc.scrollTop()) + 'px',
              left: pos.left + 'px'
          });
      },
      _isShown: function()
      {
          return (this.$list && this.$list.hasClass('open'));
      },
      _show: function()
      {
          this.$list.addClass('open');
          this.$list.show();

          this.$doc.off('.redactor-plugin-handle');
          this.$doc.on('click.redactor-plugin-handle keydown.redactor-plugin-handle', this._hide.bind(this));
      },
      _hide: function(e)
      {
          var hidable = false;
          var key = (e && e.which);

          if (!e) hidable = true;
          else if (e.type === 'click' || key === this.keycodes.ESC || key === this.keycodes.SPACE) hidable = true;

          if (hidable) {
             this._hideForce();
          }
      },
      _hideForce: function() {
          // $list is only created in _build() after a successful load, so it can
          // be undefined when _handle bails out (e.g. user types/presses Enter
          // with no active "@" before the caret) before any dropdown was built.
          if (this.$list) {
              this.$list.removeClass('open');
              this.$list.hide();
          }
          this._reset();
      },
      _reset: function()
      {
          this.handleStr = '';
          this.handleLen = this.handleStart;
      }
  // _replace is defined via prototype override in redactor_main.js
  // to handle both click and keyboard Enter with proper null-guards
  });

})(Redactor);